import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=9438b2ca&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=9438b2ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9438b2ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9438b2ca')) {
      api.createRecord('9438b2ca', component.options)
    } else {
      api.reload('9438b2ca', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=9438b2ca&scoped=true&", function () {
      api.rerender('9438b2ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24Y8rfSZK1KVJ/JS/comp/GuestBox.vue"
export default component.exports